<tr *transloco="let t">
  <td>
    <div class="title">
      <span>{{ teacher.lastName }} {{ teacher.firstName }}</span>
      <i *ngIf="false" [ngbTooltip]="t('pap/autoEvaluation/shared')" placement="top" class="material-symbols-rounded"> group </i>
    </div>
  </td>

  <td>
    <div>{{ teacher.groups | formatTeacherGroups }}</div>
  </td>
  <td>
    <div class="evaluation-date">
      <span *ngIf="teacher.lastEvaluationDate">{{ teacher.lastEvaluationDate | date : 'd. M. y' }}</span>
      <span *ngIf="teacher.resultsCount > 1" class="evaluation-results-count">+{{ teacher.resultsCount - 1 }}</span>
    </div>
    <span *ngIf="!teacher.lastEvaluationDate" class="text-primary fw-bold">{{ t('pap/autoEvaluation/notEvaluated') }}</span>
  </td>
  <td>
    <div class="d-flex align-items-center justify-content-end gap-3" style="height: 25px">
      <span *ngIf="nextEvaluationDate" class="fw-bold" [class.text-success]="isCompleted" [class.text-primary]="!isCompleted">{{
        nextEvaluationDate | date : 'd. M. y'
      }}</span>
      <span *ngIf="isCompleted" class="material-symbols-rounded filled text-success">
        <ng-container *ngIf="teacher.hasSharedResults">visibility</ng-container>
        <ng-container *ngIf="!teacher.hasSharedResults">check_circle</ng-container>
      </span>
      <span *ngIf="!isCompleted" class="material-symbols-rounded filled text-primary">error</span>
    </div>
  </td>
</tr>
